export interface GetArgs {
  productId: number;
  storeId: number;
}

export const materializedMenuProductUrls = {
  get: ({ productId, storeId }: GetArgs) =>
    `/v1/materialized_menu_products?store_id=${storeId}&product_id=${productId}`,
  search: () => `/v1/materialized_menu_products/search`,
};
